import { getConnectedAccountHeaders } from 'owa-connected-account-headers';
import { assertNever } from 'owa-assert';
import { getUserMailboxInfo, MailboxInfo, MailboxType } from 'owa-client-ids';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

export async function getDefaultRequestHeaders(
    mailboxInfo: MailboxInfo
): Promise<{ [headerName: string]: string }> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return getExplicitLogonHeaders(mailboxInfo.deprecatedMailboxId);
            case MailboxType.UserMailbox:
                let headers: { [headerName: string]: string } = {};

                // for all non-primary, connected accounts, get the token and anchor mailbox from owa-accounts-store
                if (mailboxInfo.primarySmtpAddress != getUserMailboxInfo().primarySmtpAddress) {
                    headers = await getConnectedAccountHeaders(mailboxInfo.primarySmtpAddress);
                }
                return headers;
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return {};
    }
}
